import { render, staticRenderFns } from "./TransactionsView.vue?vue&type=template&id=b58afc5a&"
import script from "./TransactionsView.vue?vue&type=script&lang=ts&"
export * from "./TransactionsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports